import { IconBase, IconComponent } from './BaseIcon';

export const Resize: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M2 18.1V30h14V16H2zm2-.1h10v10H4V18zM26 2v2h2v2h2V2h-4zM10 2h4v2h-4zM17.29 2h5v2h-5zM4 4h2V2H2v4h2V4zM2 10h2.04v4H2zM18 28h4v2h-4zM28 28h-2v2h4v-4h-2v2zM28 10h2.04v4H28zM28 18h2v4h-2zM19 9h2.59l-5.3 5.29 1.42 1.42 5.29-5.3V13h2V7h-6v2z" />
  </IconBase>
);
